import { createContext, useContext } from 'react';
import useCorporateMarketPageDeals, { ICorporateMarketPageDealsCollection } from './useMarketPageDeals';
import { IMarketPagePayload } from '@/creditflowresearch/application/Deal/types';

export type { ICorporateMarketPageDealsCollection };

type CorporateMarketPageContextType = ReturnType<typeof useCorporateMarketPageDeals>;

export const CorporateMarketPageContext = createContext<CorporateMarketPageContextType>(null);

export const useCorporateMarketPageContext = () => {
  const context = useContext(CorporateMarketPageContext);
  if (!context) {
    throw new Error('useCorporateMarketPageContext must be used within the CorporateMarketPageContext');
  }
  return context;
};

interface ICorporateMarketPageContextProps {
  children: React.ReactNode,
  deals: ICorporateMarketPageDealsCollection,
  fetch?: (payload: IMarketPagePayload) => Promise<ICorporateMarketPageDealsCollection>,
}

const CorporateMarketPageContextProvider = ({
  children,
  deals,
  fetch,
}: ICorporateMarketPageContextProps) => {
  const value = useCorporateMarketPageDeals({
    deals,
    fetch,
  });

  return (
    <CorporateMarketPageContext.Provider value={ value }>
      { children }
    </CorporateMarketPageContext.Provider>
  );
};

export default CorporateMarketPageContextProvider;
